<template>
	<div class="">
		<div class="leidatu" id="leida"></div>
	</div>
</template>

<script>

	export default {
		name: "",
		components: {

		},
		data() {
			return {}
		},
    props: {
      list: {
        type: Array
      },
      clist: {
        type: Array
      }
    },
		mounted(){
			var myChart = this.$echarts.init(document.getElementById('leida'));
			var	option = {
				    tooltip: {},
				    radar: {
				        // shape: 'circle',
                radius:'65%',
				        splitNumber: 4,
				        name: {
				            textStyle: {
				                color: '#666',
				                padding: [5, 5]
				            }
				        },
				        indicator: this.clist
				    },
				    series: [{
				        name: '性格测评雷达图',
				        type: 'radar',
				        areaStyle: {
				            normal: {
				                width: 1,
				                opacity: 0.7,
				            },
				        },
				        data: [{
				            itemStyle: {
				                normal: {
				                    color: '#67abff',
				                    lineStyle: {
				                        color: '#67abff',
				                    },
				                },
				            },
				            value: this.list
				        }]
				    }]
				};
			// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
		},
		methods: {

		}


	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/tubiao/cepingjieguo1.vue